import { Box } from '@chakra-ui/react';
import React from 'react';
import desktop from '@/assets/sterlingparker/images/carousel/web.png';
import mobile from '@/assets/sterlingparker/images/carousel/mobile.png';
import Carousel from '@/components/Carousel';

export default function Index() {
  return (
    <Box
      sx={{
        mb: ['14px', null, '12px'],
        borderBottom: ['4px solid #cc952b', null, 'unset'],
      }}
    >
      <Carousel
        slides={[
          <Box
            key="banner-image"
            sx={{
              w: '100%',
              h: ['360px', null, '215px'],
              bgImage: [mobile, null, desktop],
              bgSize: ['contain', null, 'cover'],
              bgPos: ['center', null, '100% 12%'],
              bgRepeat: 'no-repeat',
            }}
          />,
        ]}
      />
    </Box>
  );
}
